import apiClient from '../services/apiClient'
import { DashboardConfig, DashboardConfigResponse } from '../pages/admin/dashboard/types/dashboard.type'

export const getDashboardConfig = async (): Promise<DashboardConfigResponse> => {
  return (await apiClient.get('/admin-dashboard-config')).data
}

export const createDashboardConfig = async (config: DashboardConfig): Promise<DashboardConfigResponse> => {
  return (await apiClient.post('/admin-dashboard-config', { config })).data
}

export const updateDashboardConfig = async (config: DashboardConfig): Promise<DashboardConfigResponse> => {
  return (await apiClient.put('/admin-dashboard-config', { config })).data
}

export const deleteDashboardConfig = async (): Promise<void> => {
  await apiClient.delete('/admin-dashboard-config')
}
